var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateRange24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9984 22.0013C21.0984 22.0014 21.9984 21.1015 21.9985 20.0015L21.9997 6.00148C21.9998 4.90148 21.0998 4.0014 19.9998 4.00131L18.9998 4.00123L19 2.00123L17 2.00107L16.9998 4.00107L8.99984 4.00041L9 2.00041L7 2.00025L6.99984 4.00025L5.99984 4.00016C4.88984 4.00007 4.00976 4.9 4.00967 6L3.99852 20C3.99843 21.1 4.88836 22.0001 5.99836 22.0002L19.9984 22.0013ZM9.9991 13.0005L9.99926 11.0005L7.99926 11.0003L7.9991 13.0003L9.9991 13.0005ZM5.99951 8.00016L19.9995 8.00131L19.9997 6.00131L5.99967 6.00016L5.99951 8.00016ZM19.9993 10.0013L19.9985 20.0013L5.99852 20.0002L5.99934 10.0002L19.9993 10.0013ZM17.9991 13.0011L17.9993 11.0011L15.9993 11.001L15.9991 13.001L17.9991 13.0011ZM13.9991 13.0008L11.9991 13.0007L11.9993 11.0007L13.9993 11.0008L13.9991 13.0008Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRange24Px);
export default __webpack_public_path__ + "static/media/date_range_24px.69147eae811020d0cad93f2051d53bb1.svg";
export { ForwardRef as ReactComponent };